import React from "react";
import client, { isSignedIn } from "@culturehq/client";

import { Icon, Thumbnail } from "@culturehq/components";

import chatbubble from "images/chatbubble.png";

import { displayLastName, getDuration, getImageFromStory, getUserName, isMultiImageStory } from "app/utils";
import imagesSizes from "constants/imagesSizes";

import CheerList from "components/common/cheers/CheerList";
import LazyEditorOutput from "components/editor/LazyEditorOutput";
import TrendsetterBadge from "components/feed/feed-item/preview/story-created/TrendsetterBadge";
import SocialChannel from "./SocialChannel";

const StoryThumbnail = ({
  story,
  index,
  isTrendsetter,
  onClick,
  showCreator = true,
  showQuestion = false,
  showAnswer = true,
  showCreatorTitle = false,
  showActions = true,
  landingPage = false,
  onOverStory,
  onLeaveStory,
  organization,
  isEducational,
  ariaLabelledby
}) => {
  const isSigned = isSignedIn();

  return (
    <div
      aria-labelledby={ariaLabelledby ? story.id : undefined}
      className="PhotoGroup__thumbnail Story"
      onClick={() => onClick(index)}
      onKeyDown={e => { if (e.key === "Enter") onClick(index); }}
      role="button"
      tabIndex={0}
      onMouseEnter={() => {
        if (onOverStory) {
          onOverStory(story);
        }
      }}
      onMouseLeave={() => {
        if (onLeaveStory) {
          onLeaveStory();
        }
      }}
    >
      <div id={story.id} style={{ display: "none" }}>
        {`${landingPage ? getUserName(story.creator, displayLastName(organization)) : story.creator.name}'s story about ${story.question.question}`}
      </div>
      <img
        className="story--image"
        src={
          story.media?.mediaType === "video"
            ? story.media?.thumbnail
            : getImageFromStory(imagesSizes.NORMAL, story)
        }
        alt={story.imageAlt || story.question.question}
      />
      <div className="Story__information--profile">
        <div className="background-container">
          {showCreator && (
            <div className="Story__creator">
              <Thumbnail image={story.creator.avatar.thumbUrl} />
              <div>
                <p className="Story__creator-text">
                  {landingPage
                    ? getUserName(story.creator, displayLastName(organization))
                    : story.creator.name}
                </p>
                {showCreatorTitle
                && isEducational
                && story.creator.programs?.length > 0 ? (<p className="Story__creator-text Story__creator-title">{story.creator.programs[0].name}</p>
                  ) : (
                    <p className="Story__creator-text Story__creator-title">
                      {story.creator.title}
                    </p>
                  )}
              </div>
            </div>
          )}
          {showQuestion && (
            <span className="Story__question">{story.question.question}</span>
          )}
          <div className="Story_Badges__Container">
            {isTrendsetter && <TrendsetterBadge justIcon />}
            {story?.socialShares
              ?.map(share => share.socialType)
              .filter((value, index, self) => self.indexOf(value) === index)
              .map(type => (
                <SocialChannel key={type} justIcon socialType={type} />
              ))}
          </div>
          {showActions && isSigned && (
            <div className="Story__actions">
              <div className="Messages__container">
                <img
                  className="Messages__icon"
                  src={chatbubble}
                  alt="Messages badge"
                />
                {story.commentCount > 0 && (
                  <span className="Messages__container--badge">
                    {story.commentCount}
                  </span>
                )}
              </div>
              <CheerList
                cheersPath={`/stories/${story.id}/cheers`}
                entity={story}
                showCheerButton={false}
                isUserProfile
              />
            </div>
          )}
          {isMultiImageStory(story) && (
            <div className="MultiImage__container">
              <Icon icon="images" />
            </div>
          )}
          {story.media.mediaType === "video" && (
            <span className="Story__badge">
              <Icon icon="play-no-border" />
              {getDuration(story.media?.duration)}
            </span>
          )}
        </div>
      </div>
      {showAnswer && (
        <div className="Story__information--profile Story__answer">
          <div className="background-container">
            <LazyEditorOutput
              output={story.body}
              showTags={false}
              landingPage={landingPage}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default StoryThumbnail;
